<template>
    <main class="main">
        <div class="main__page">
            <div class="card__header">
                <h2 class="main-title">
                    {{ $t('users.title') }}
                </h2>
                <router-link class="card__header-link" :to="{ name: 'user', params: {id: 'new'}}">
                    <span class="btn-icon">
                        <span class="bar"></span>
                        <span class="bar"></span>
                    </span>
                    <span class="btn-label">
                        {{ $t('common.add') }}
                    </span>
                </router-link>
            </div>
            <div class="card">
                <div class="card__detail">
                    <div class="users__list">
                        <header class="users__list-head">
                            <span class="users__list-head--col name">Name</span>
                            <span class="users__list-head--col name">E-mail</span>
                        </header>
                        <div class="users__list loading">
                            <div class="user" v-for="user in this.users.data">
                                <router-link class="user__link" :to="{ name: 'user', params: { id: user.id } }">
                                    <span class="user__name">
                                        {{ user.name }}
                                    </span>
                                    <span class="user__email">
                                        {{ user.email }}
                                    </span>
                                </router-link>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="table loading">
                        <table>
                            <thead>
                            <tr>
                                <th>Nome</th>
                                <th>Email</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="user in this.users.data">
                                <td>
                                    <router-link
                                            :to="{ name: 'user', params: {id: user.id}}">
                                        {{ user.name }}</router-link>
                                </td>
                                <td>{{ user.email }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div> -->
                    <Pagination v-model="users"></Pagination>
                </div>
            </div>
        </div>
    </main>
</template>
<script>
    import Pagination from "../../components/Pagination";

    export default {
        name: 'users',
        components: {Pagination},
        mounted() {
            this.init();
        },
        data() {
            return {
                'users': this.api.users
            }
        },
        methods: {
            init() {
                this.users = this.api.users;
                this.users.getList();
            }
        }
    }
</script>
<style lang="scss">
    @import './src/scss/variables';
    .card {
        &__header {
            display: flex;
            justify-content: space-between;
            background: transparent;
            height: auto;
            padding: 30px 0;
            .card__header-link {
                display: flex;
                align-items: center;
                justify-content: flex-end;
                background: $middle-green;
                padding: 10px 20px;
                transition: 300ms $ease-out-quint;
                .btn {
                    &-icon .bar,
                    &-label {
                        transition: 300ms $ease-out-quint;
                    }
                    &-icon {
                        display: block;
                        width: 20px;
                        height: 20px;
                        margin-right: 15px;
                        position: relative;
                        .bar {
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            background: $white;
                            width: 15px;
                            height: 4px;
                            transform: translate(-50%,-50%);
                            &:last-of-type {
                                transform: translate(-50%,-50%) rotate(90deg);
                            }
                        }
                    }
                    &-label {
                        display: block;
                        font-weight: 700;
                        font-size: 0.8em;
                        color: $white;
                        text-transform: uppercase;
                    }
                }
                &:hover {
                    background: $white;
                    .btn {
                        &-icon .bar { background: $middle-green; }
                        &-label { color: $middle-green; }
                    }
                }
            }
        }
    }
    .users__list {
        --col-width: 30vw;
        display: flex;
        flex-direction: column;
        &-head {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            width: 100%;
            &--col {
                font-weight: 700;
                font-size: 0.9em;
                color: rgba($gray, 0.5);
                text-transform: uppercase;
                padding: 10px;
                &.name {
                    width: var(--col-width);
                }
            }
        }
        .user {
            display: block;
            width: 100%;
            padding: 15px 10px;
            position: relative;
            &:before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                background: $middle-green;
                width: 100%;
                height: 100%;
                z-index: 1;
                transform: scaleY(0);
                transform-origin: center bottom;
                transition: 600ms $ease-out-quint;
            }
            &__link {
                display: flex;
                align-items: center;
                justify-content: flex-start;
            }
            &__name,
            &__email {
                position: relative;
                z-index: 2;
                transition: 600ms $ease-out-quint;
            }
            &__name {
                display: block;
                width: var(--col-width);
                font-size: 1.5em;
                font-weight: 300;
                padding-bottom: 7px;
            }
            &__email {
                display: block;
                width: calc(100% - var(--col-width));
                color: $gray;
            }
            &:nth-of-type(even) {
                background: rgba($gray, 0.05);
            }
            &:hover {
                .user__name,
                .user__email {
                    color: $white;
                }
                &:before {
                    transform: scaleY(1);
                    transform-origin: center top;
                }
            }
        }
    }
</style>
